import React, {useState} from "react";
import {linkProject} from "../../api/apiLibrary";
import {Drawer, makeStyles} from '@material-ui/core';
import {Loading} from "../common/Loading";
import {Error} from "../common/Error";

const useStyles = makeStyles({
    paper: {
        left: "50%"
    }
});

export const LinkProjectComponent = (props) => {
    const classes = useStyles();

    const {checkedPieces, isChecked, setIsChecked, setCheckedPieces, projects, successCallback, errorCallback} = props;

    const [rightPartIsOpen, setRightPartIsOpen] = useState(false);

    const handleClick = async (project) => {

        await linkProject(checkedPieces, project)
            .then(() => {
                setRightPartIsOpen(false);
                setIsChecked(false);
                setCheckedPieces([]);
                projects.refetch().then(() => {
                    successCallback('Les pièces ont été ajoutées au projet.')
                })
            })
            .catch(() => {
                projects.refetch().then(() => errorCallback('Une erreur est survenue.'))
            });
    }

    return (
        <>
            <button className="button-link" id="btn-link-project" onClick={() => setRightPartIsOpen(!rightPartIsOpen)} disabled={!isChecked}><i className="fa fa-link"/> Associer les pièces à un projet</button>
            <Drawer anchor="right" open={rightPartIsOpen} onClose={() => setRightPartIsOpen(!rightPartIsOpen)} classes={{paper: classes.paper}}>

            <div id="main__library-link-project">

                    <div id="library__projects">

                        <div id="library__projects-list-container" className="block">
                            <h2>Associer des pièces à un projet</h2>

                            <div id="library__projects-list">
                                <div id="projects-list__background"/>
                                <p>Sélectionner un projet de la liste pour y ajouter les pièces.</p>

                                {
                                    projects.isLoading ? <Loading/> :
                                        projects.isError ? <Error errorMessage={projects.error.message}/> :
                                    Object.entries(projects.data).length ? (
                                        projects.data.map((project) => (
                                            <div key={project.id} className="projects-list__project-item" onClick={() => handleClick(project)}>
                                                <span className="project-item__color" style={{background: project.color.hex_code}} />
                                                {project.name}
                                            </div>
                                        ))
                                    ) : 'Aucun projet'
                                }

                            </div>
                        </div>

                    </div>

                </div>
            </Drawer>
        </>
    )

}

